


























import { Component, Vue } from "vue-property-decorator";
import { fetchArticle } from "../services/RealAPI";

@Component
export default class Article extends Vue {
  article = {};
  isLoading = true;
  async mounted() {
    this.isLoading = true;
    const articleId = parseInt(this.$route.params.articleId);
    this.article = await fetchArticle(articleId);
    this.isLoading = false;
  }
}
